import { gateway, getProfile, logout } from "api/shared/authentication"

import { store } from 'redux/storeConfig/store'
import { history } from "app-history"

export const appAuthenticate = (permissions) => {
  store.dispatch(appToggleLoading(true))
  return async () => {
    const success = await gateway()
    const role = success ? 'user' : 'public'

    store.dispatch(appUpdateRole(role))
    store.dispatch(appToggleAuthenticated(success))

    _bounce(permissions)
  }
}

export const appBouncerCheck = (permissions) => {
  return async () => _bounce(permissions)
}

export const _bounce = (permissions) => {
  const { app: { authenticated } } = store.getState()

  const nonPublicRoute = !permissions.includes('public')
  if (nonPublicRoute && !authenticated) history.push('/auth')

  const onlyPublicRoute = permissions.length === 1 && permissions[0] === 'public'
  if (onlyPublicRoute && authenticated) history.push('/app/home')
  store.dispatch(appToggleLoading(false))
}

export const appToggleLoading = (data) => {
  return dispatch => dispatch({ type: "APP_TOGGLE_LOADING", data })
}

export const appTogglePageLoading = (data) => {
  return dispatch => dispatch({ type: "APP_TOGGLE_PAGE_LOADING", data })
}

export const appUpdateRole = (data) => {
  return dispatch => dispatch({ type: "APP_UPDATE_ROLE", data })
}

export const appToggleAuthenticated = (data) => {
  return dispatch => dispatch({ type: "APP_TOGGLE_AUTHENTICATED", data })
}

export const appAuthenticateOut = () => {
  return async () => {
    const success = await logout()
    const role = success ? 'public' : 'user'
    store.dispatch(appUpdateRole(role))
    store.dispatch(appToggleAuthenticated(!success))
  }
}

export const appFetchNavigationProfile = () => {
  return async (dispatch) => {
    const data = await getProfile()
    if (!data.error) {
      dispatch({ type: "APP_UPDATE_NAVIGATION_PROFILE", data })
    }
  }
}
